import LogoutContainer from "./LogoutContainer";

export default LogoutContainer;
